import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { GlobalsService, ToolboxService } from '../../shared/services';
import {
  ModalLogoutComponent,
  LoadingGlobalService,
} from '../../shared/components';
import { SieniService } from 'src/app/shared/services/sieni.service';
import { MToolboxDashboard } from 'src/app/shared/models/ToolboxDashboard.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  auth: boolean;
  slideMenu = 'slide-open';
  imgUrl: string;
  openProfile = false;
  user: any = {};
  imgSrc: string;
  menu: any;
  colorBar: string;
  title: string;
  etiquetas: any;

  constructor(
    private globals: GlobalsService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private toolboxService: ToolboxService,
    private toastrService: ToastrService,
    private loadingGlobalService: LoadingGlobalService,
    private translate: TranslateService,
    private _globalService: SieniService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.toolboxService.listToolbox();

    this.user = this.globals.user;
    // console.log(this.user,"USUARIO");

    if (this.user === undefined) {
      this.globals.dataFirst.subscribe((resp: any) => {
        this.user = resp.user;
      });
    } else {
      this.translate.setDefaultLang('en');
      
      this.translate.use(this.globals.user.language.code);
    }

    const locale = this.user ? this.user.language.code : 'es';
    // console.log(locale,"LANGUAGE");

    this.translate.use(locale);
    this.getTranslate();

    const avatar = this.user ? this.user.avatar : null;
    this._globalService
      .getSettings('site', 'logo')
      .subscribe(
        (res: any) =>
          (this.imgUrl = this.globals.imgUrl + '/storage/' + res.data)
      );
    this.imgSrc = this.globals.imgUrl + '/storage/' + avatar;

    if (this.user) {
      this.listMenu();
    }

    const w = window.innerWidth;
    if (w <= 767) {
      this.slideMenu = 'slide-close';
    }

    this.toolboxService.getCheckView.subscribe((resp: any) => {
      this.auth = resp !== undefined ? resp.check : undefined;
      if (resp !== undefined) {
        if (resp.message) {
          this.toastrService.error(resp.message, '', {
            timeOut: 0,
          });
        } else if (!resp.check && !resp.message) {
          this.toastrService.error(
            this.etiquetas.message.not_authorize,
            this.etiquetas.message.error,
            {
              timeOut: 0,
            }
          );
        }
      }
    });
  }

  // Animación para abrir y cerrar el menu
  menuClick() {
    const w = window.innerWidth;
    this.slideMenu =
      this.slideMenu === 'slide-open' ? 'slide-close' : 'slide-open';
  }

  // Abrir y cerrar la informacion del perfil del usuario
  profileInfo() {
    this.openProfile = this.openProfile === true ? false : true;
  }

  // Cerrar información del perfil del usuario haciendo click en cualquier parte
  onClickedOutside(event) {
    this.openProfile = false;
  }

  logOut() {
    this.modalService.open(ModalLogoutComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
    });
  }

  listMenu() {
    const sub = this.toolboxService.listMenu().subscribe(
      (resp: any) => {
        sub.unsubscribe();
        // console.log(resp)
        this._globalService.setToolbox(new MToolboxDashboard(resp.data));
        this.colorBar = resp.data.color;
        this.title = resp.data.nombre;
        this.menu = resp.data.menu.menu_items;
        this.titleService.setTitle(resp.data.nombre);

        this.loadingGlobalService.hide();
      },
      (error: any) => {
        sub.unsubscribe();
        console.error('Error al consultar lista del menu', error);
      }
    );
  }

  getTranslate() {
    this.translate.get('globals').subscribe((resp: any) => {
      this.etiquetas = resp;
    });
  }
}
